var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    [
      _c("breadcrumbs", { attrs: { items: _vm.breadcrumbs } }),
      _c("v-container", [
        _c(
          "div",
          { staticClass: "container-user" },
          [
            _c(
              "div",
              { staticClass: "round-action" },
              [
                _c(
                  "v-row",
                  { staticClass: "btn-div", attrs: { justify: "start" } },
                  [
                    _c("v-col", [
                      _c(
                        "div",
                        { staticClass: "area-search-box" },
                        [
                          _c(
                            "v-row",
                            {
                              attrs: {
                                "no-gutters": "",
                                justify: "space-between",
                              },
                            },
                            [
                              _c(
                                "v-col",
                                [
                                  _c("searchbox", {
                                    staticClass: "input-search",
                                    attrs: {
                                      searchTargetItems: _vm.searchTargetItems,
                                      dataOffice: _vm.dataOffice,
                                      dataArea: _vm.dataArea,
                                      gateCode: _vm.gateCode,
                                      disabled: _vm.isDisable,
                                      isCSV: true,
                                      showTimePicker: true,
                                      entranceHistoryPage: true,
                                    },
                                    on: {
                                      search: function ($event) {
                                        return _vm.$emit("search", $event)
                                      },
                                      export: function ($event) {
                                        return _vm.$emit("export", $event)
                                      },
                                      "change-office": function ($event) {
                                        return _vm.changeOffice($event)
                                      },
                                      "change-area": function ($event) {
                                        return _vm.changeArea($event)
                                      },
                                    },
                                  }),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ]),
                  ],
                  1
                ),
              ],
              1
            ),
            _vm.loadingSearch === false
              ? _c("entrance-history-list", {
                  attrs: {
                    loading: _vm.loading,
                    resData: _vm.resData,
                    perPage: _vm.perPage,
                    loadMore: _vm.loadMore,
                    page: _vm.page,
                    total: _vm.total,
                  },
                  on: {
                    "change-column": function ($event) {
                      return _vm.$emit("change-column", $event)
                    },
                    "change-per-page": function ($event) {
                      return _vm.$emit("change-per-page", $event)
                    },
                    "change-page": function ($event) {
                      return _vm.$emit("change-page", $event)
                    },
                    "get-current-items": function ($event) {
                      return _vm.$emit("get-current-items", $event)
                    },
                  },
                })
              : _vm._e(),
          ],
          1
        ),
      ]),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }